import {
  KeyboardAvoidingView as RNKeyboardAvoidingView,
  KeyboardAvoidingViewProps,
} from "react-native"

export function KeyboardAvoidingView(props: KeyboardAvoidingViewProps) {
  return (
    <RNKeyboardAvoidingView
      behavior="padding"
      contentContainerStyle={{ flex: 1 }}
      style={{ flex: 1 }}
      keyboardVerticalOffset={20}
      {...props}
    />
  )
}
